import { useFormContext } from '@/frontend/components/form/form-context'
import { cn } from '@/frontend/lib/utils'

interface FormDebugProps extends Omit<React.ComponentProps<'div'>, 'children'> {
  enabled?: boolean
}

export function FormDebug({ enabled = true, className }: FormDebugProps) {
  const form = useFormContext()

  if (!enabled) return null

  return (
    <form.Subscribe selector={(state) => state}>
      {(state) => (
        <div
          className={cn(
            'rounded-lg border bg-muted p-4 text-sm font-mono overflow-auto',
            className
          )}
        >
          <details>
            <summary className="cursor-pointer font-medium mb-2">Form Debug</summary>
            <div className="space-y-2">
              <div>
                <strong>Values:</strong>
                <pre>{JSON.stringify(state.values, null, 2)}</pre>
              </div>
              <div>
                <strong>Errors:</strong>
                <pre>{JSON.stringify(state.errors, null, 2)}</pre>
              </div>
              <div>
                <strong>State:</strong>
                <pre>
                  {JSON.stringify(
                    {
                      isSubmitting: state.isSubmitting,
                      isValidating: state.isValidating,
                      canSubmit: state.canSubmit,
                      isPristine: state.isPristine,
                      isDirty: state.isDirty,
                      isTouched: state.isTouched,
                    },
                    null,
                    2
                  )}
                </pre>
              </div>
            </div>
          </details>
        </div>
      )}
    </form.Subscribe>
  )
}
